import React from "react"
import Layout from "../Layout"
import Menu from "../Menu"
import Main from "../Main"

function map(children: React.ReactNode) {
	return React.Children.map(children, child => (React.isValidElement(child) ? child : null))
}

interface ComponentWrapperProps {
	children: React.ReactNode
	active: number
	subMenuActive?: number
}

const ComponentWrapper = ({children, active, subMenuActive}: ComponentWrapperProps) => {
	return (
		<Layout>
			<Menu active={active} subMenuActive={subMenuActive} />
			<Main>{map(children)}</Main>
		</Layout>
	)
}

export default ComponentWrapper